import { GButton } from 'components/basic-blocks'
import { useStores } from '../../../../../hooks'
import { useNavigate } from 'react-router-dom'
import { FiArrowRightCircle } from 'react-icons/fi'
import ServerSideTrackingPromoImage from '../../../../../assets/img/server-side-tracking-promo.png'
import { useTrackPostHogEvent } from '../../../../../utils/posthog'
import { PostHogEvent, PostHogPath } from '../../../../../utils/posthog-events'

export const ServerSideTrackingPromo = () => {
	const {
		accountStore: { account }
	} = useStores()
	const navigate = useNavigate()
	const trackPostHogEvent = useTrackPostHogEvent()

	const handleUpgrade = () => {
		if (account?.id) {
			navigate(`/settings/workspace/${account.id}/billing`)
		}
	}

	return (
		<div className="flex flex-col lg:flex-row gap-8 items-center">
			<div className="flex-1">
				<p className="text-xl md:text-2xl text-t-base-blue mb-3">
					Server-side tracking is here!
				</p>
				<p className="text-lg text-t-checkbox-unactive mb-6">
					Your traffic insights now sharper than ever
				</p>

				<ul className="space-y-3 mb-8">
					<li className="flex items-start gap-3">
						<span className="text-[#8F88FF] text-[32px]">•</span>
						<span className="text-base text-t-default">
							Bypasses ad blockers and browser tracking limitations
						</span>
					</li>
					<li className="flex items-start gap-3">
						<span className="text-[#8F88FF] text-[32px]">•</span>
						<span className="text-base text-t-default">
							Identify fraudulent behavior earlier and more clearly
						</span>
					</li>
					<li className="flex items-start gap-3">
						<span className="text-[#8F88FF] text-[32px]">•</span>
						<span className="text-base text-t-default">
							Turn wasted spend into conversions faster.
						</span>
					</li>
				</ul>

				<GButton
					label="Upgrade your plan"
					color="yellow"
					className="rounded-full px-6 h-[40px] border-2"
					labelClassName="font-medium text-base"
					onClick={handleUpgrade}
					icon={FiArrowRightCircle}
					iconClassName="w-5 h-5"
					iconPlacement="left"
				/>
			</div>
			<div className="flex-1 w-full max-w-[500px] lg:w-auto">
				<img
					src={ServerSideTrackingPromoImage}
					alt="Server-side tracking dashboard preview"
					className="w-full h-auto rounded-lg"
				/>
			</div>
		</div>
	)
}
